import { jsx } from "react/jsx-runtime";
import assert from "assert";
import { Button } from "../../Button/Button.mjs";
const ButtonAction = ({ onClick, icon, id, label }) => {
  assert(label, "A TextareaAction.Button requires you to pass a label.");
  assert(onClick, "A TextareaAction.Button requires you to pass an onClick function");
  return /* @__PURE__ */ jsx(Button, { onClick, variant: "transparent", size: "small", bleed: true, icon, children: label }, id);
};
export {
  ButtonAction
};
